import { QueryClient } from '@tanstack/react-query';
import { isApiProblem } from '@ticarishift/api-client/runtime';

/**
 * Sorgu istemcisi (08 §11.5; panelle aynı kural): yalnız geçici arızalar (ağ, 429, 5xx) en çok iki kez yeniden denenir;
 * yetki ve doğrulama hataları denenmez. Pencere odağında yenileme kapalıdır; Genel Bakış kendisi yoklar.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (failureCount, error) => failureCount < 2 && (!isApiProblem(error) || error.isTransient),
        refetchOnWindowFocus: false,
        staleTime: 30_000,
      },
      mutations: { retry: false },
    },
  });
}
